<template>
	<tbody>
		<tr v-for="(servico, index) in data" :key="index">
			<td>{{ servico.cod }}</td>
			<!-- <td>{{servico}}</td> -->
			<td>{{ servico.servico }}</td>
			<!-- <td>{{servico.duracao}}</td> -->
			<td>{{ servico.qnt }}</td>
			<td>
				R$
				{{
					(
						parseFloat(servico.valor) +
						(parseFloat(servico.acrescimo) -
							parseFloat(servico.desconto) / servico.qnt)
					).toFixed(2)
				}}
			</td>
			<td class="warning">
				R$
				{{
					(
						(parseFloat(servico.valor) +
							(parseFloat(servico.acrescimo) -
								parseFloat(servico.desconto) / servico.qnt)) *
						servico.qnt
					).toFixed(2)
				}}
			</td>
		</tr>
		<tr v-if="parseFloat(desconto).toFixed(2) > 0">
			<td></td>
			<td>Desconto ( - )</td>
			<td></td>
			<td></td>
			<td>- R$ {{ parseFloat(desconto).toFixed(2) }}</td>
		</tr>
		<tr v-if="parseFloat(acrescimo).toFixed(2) > 0">
			<td></td>
			<td>Acréscimo ( + )</td>
			<td></td>
			<td></td>
			<td>+ R$ {{ parseFloat(acrescimo).toFixed(2) }}</td>
		</tr>
		<tr v-if="!isNaN(parseFloat(total).toFixed(2))">
			<td></td>
			<td>Total</td>
			<td></td>
			<td></td>
			<td>R$ {{ parseFloat(total).toFixed(2) }}</td>
		</tr>
	</tbody>
</template>
<script>
	export default {
		props: ['data', 'desconto', 'acrescimo', 'total'],
	};
</script>



// WEBPACK FOOTER //
// src/components/contracts/components/lista-de-servicos.vue